import React, { FC, useMemo, useState } from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { JobFamiliesModel, JobFamilyQueryModelInput } from '@utmost.co/enterprise-models';
import { MuiSelectProps } from '@utmost.co/utmost-design-system';
import { Select } from '@beeline.com/bp-design-system';

type Props = Pick<MuiSelectProps, 'label' | 'onChange' | 'dataTest' | 'disabled' | 'value' | 'valueOptions'>;

export const JobFamilyPicker: FC<React.PropsWithChildren<Props>> = (props) => {
  const [search, setSearch] = useState<string | undefined>();
  const { data, loading } = useQuery<
    {
      jobFamilies: JobFamiliesModel;
    },
    {
      query: Partial<JobFamilyQueryModelInput>;
    }
  >(GET_JOB_FAMILIES, { variables: { query: { search } } });

  const options = useMemo(
    () => data?.jobFamilies.items.map(({ uid, name }) => ({ label: name, value: uid })),
    [data?.jobFamilies.items]
  );

  return <Select autoComplete loading={loading} onSearch={setSearch} {...props} options={options ?? []} />;
};

const GET_JOB_FAMILIES = gql`
  query GET_JOB_FAMILIES($query: JobFamilyQueryModelInput) {
    jobFamilies(query: $query) {
      items {
        uid
        name
      }
    }
  }
`;
